import { T } from "../../../app/tokens.js";
import { formatFinancialAmount, parseFinancialAmount, previousMonthEnd, monthEnd } from "../../../lib/projectFinancialAmounts.js";

export function financialDraft(financials) {
  return { ...Object.fromEntries(["budget", "forecast", "spendToDate"].map(key => [key, formatFinancialAmount(financials?.[key], "USD")])),
    actualsThrough: (financials?.actualsThrough || previousMonthEnd()).slice(0, 7) };
}
export function financialPatch(draft, financials) {
  const patch = {};
  for (const [key, field] of [["budget", "approvedBudget"], ["forecast", "forecastAtCompletion"], ["spendToDate", "spentToDate"]]) {
    const value = parseFinancialAmount(draft[key]);
    if (value !== undefined && (financials?.[key] == null || Number(financials[key]) !== value)) patch[field] = value;
  }
  if ("spentToDate" in patch) patch.actualsThrough = monthEnd(draft.actualsThrough);
  return patch;
}
export function FinancialAmountFields({ draft, setField, busy, financials }) {
  let variance = null;
  try {
    const budget = parseFinancialAmount(draft.budget) ?? financials?.budget, forecast = parseFinancialAmount(draft.forecast) ?? financials?.forecast;
    if (budget != null && forecast != null) variance = budget - forecast;
  } catch { /* Invalid drafts retain their text; Save exposes validation. */ }
  const input = { width: "100%", boxSizing: "border-box", padding: "8px", border: `1px solid ${T.border}`, borderRadius: 6, color: T.dark, background: T.white, fontSize: T.fsSm };
  return <div>
    <div style={{ display: "grid", gridTemplateColumns: "repeat(2,minmax(0,1fr))", gap: 10 }}>
      {[["budget", "Budget"], ["forecast", "Forecast"], ["spendToDate", "Spend to date"]].map(([key, text]) =>
        <label key={key} style={{ fontSize: T.fsXs, color: T.mid }}>{text}
          <input aria-label={text} data-testid={`fin-input-${key}`} inputMode="decimal" disabled={busy}
            style={input} value={draft[key] ?? ""} onChange={e => setField(key, e.target.value)}
            onBlur={() => { try { const amount = parseFinancialAmount(draft[key]); if (amount !== undefined) setField(key, formatFinancialAmount(amount)); } catch { /* Save validates. */ } }} />
        </label>)}
      <label style={{ fontSize: T.fsXs, color: T.mid }}>Actuals through
        <input aria-label="Actuals through" type="month" style={input} disabled={busy} value={draft.actualsThrough || ""} onChange={e => setField("actualsThrough", e.target.value)} />
      </label>
    </div>
    <div style={{ marginTop: 8, fontSize: T.fsSm }}>Variance: <output aria-label="Variance">{variance == null ? "Not recorded" : formatFinancialAmount(variance)}</output></div>
    <div style={{ marginTop: 4, fontSize: T.fsXs, color: T.mid }}>Variance = Budget − Forecast.</div>
  </div>;
}
